<template>
  <div v-show="this.tabName === this.name">
    <slot></slot>
  </div>
</template>

<script>
import {inject} from 'vue';

export default {
  name: "Tab",
  props: {
    name: {required: true},
    selected: {default: false}
  },
  data: function () {
    return {
      isActive: false
    };
  },
  setup() {
    const tabName = inject('tabName');

    return {tabName};
  },
}
</script>